// CPI-1284: book-api's storey-plan sales chart takes `?language=EN|VN` and opens in that language.
// Map this app's i18n code onto it: every Vietnamese code (`vi`, `vi-VN`, `vi_VN`) is VN, anything
// else - English, Bahasa Indonesia, unset - is EN, the chart's own default.
export const chartLanguage = lng => (
  String(lng || '').trim().toLowerCase().startsWith('vi') ? 'VN' : 'EN'
);

export default chartLanguage;



// WEBPACK FOOTER //
// ./src/utils/chartLanguage.js